export default __webpack_public_path__ + "static/media/sittingDog.56af32be.png";